var moment = require("moment-timezone"); moment.tz.add('Asia/Ho_Chi_Minh|+07|-70|0||90e5');